<template>
  <div class="search-wrapper">
    <svg class="search-icon" width="16.928223" height="16.928223" viewBox="0 0 16.9282 16.9282" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs/>
      <path id="Vector" d="M13.35 12.18L16.92 15.74L15.74 16.92L12.18 13.35C10.85 14.42 9.2 15 7.5 15C3.36 15 0 11.64 0 7.5C0 3.35 3.36 0 7.5 0C11.63 0 15 3.35 15 7.5C15 9.2 14.42 10.85 13.35 12.18ZM11.68 11.56C12.74 10.47 13.33 9.01 13.33 7.5C13.33 4.27 10.72 1.66 7.5 1.66C4.27 1.66 1.66 4.27 1.66 7.5C1.66 10.72 4.27 13.33 7.5 13.33C9.01 13.33 10.47 12.74 11.56 11.68L11.68 11.56Z" fill="#1D1D34" fill-opacity="1.000000" fill-rule="nonzero"/>
      </svg>

    <input 
      type="text" 
      v-model="searchQuery" 
      placeholder="Search" 
      @input="onInput($event.target.value)"
      @focus="showDropdown = true"
      @blur="hideDropdown"
    />
    <button v-if="searchQuery" class="clear-btn" @click="clearSearch">
      <svg width="10.606689" height="10.606445" viewBox="0 0 10.6067 10.6064" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Vector" d="M5.3 4.12L9.42 0L10.6 1.17L6.48 5.3L10.6 9.42L9.42 10.6L5.3 6.48L1.17 10.6L0 9.42L4.12 5.3L0 1.17L1.17 0L5.3 4.12Z" fill="#1D1D34" fill-opacity="1.000000" fill-rule="nonzero"/>
      </svg>
    </button>

    <ul v-if="sort.length > 0 && showDropdown === true"  class="dropdown">
      <li 
        v-for="option in sort"
        :key="option.id" 
        @mousedown.prevent="selectItem(option)"
      >
        {{ option[data_name] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sort: {
      type: Array,
      default: () => [],
    },
    data_name: String,
  },
  data() {
    return {
      searchQuery: '',
      showDropdown: false,
    };
  },
  methods: {
    onInput(value) {
      this.showDropdown = !!this.searchQuery;
      this.$emit('search', value);
    },
    clearSearch() {
      this.searchQuery = '';
      this.showDropdown = false;
      this.$emit('update:modelValue', '');
    },
    selectItem(item) {
      this.searchQuery = item[this.data_name];
      this.showDropdown = false;
      this.$emit('update:modelValue', item.id);
    },
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0px 26px;
  width: 100%;
  height: 48px;
  max-width: 640px;
  box-sizing: border-box;
  border: 1px solid rgb(233, 233, 237);
  border-radius: 322px;

  /* General colors/0 */
  background: rgb(255, 255, 255);
}

.search-icon {
  width: 20px;
  height: 20px;
  color: #888;
  margin-right: 8px;
}

input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
}

.clear-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #888;
  cursor: pointer;
  padding: 0;
}

.clear-btn:hover {
  color: #000;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  list-style: none;
  padding: 0;
  margin: 4px 0 0 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.dropdown li {
  padding: 10px;
  cursor: pointer;
}

.dropdown li:hover {
  background: #f0f0f0;
}
</style>
